<template>
  <div id="headtop" ref="headtop" :class="headactive == 1? 'active':''">
    <div id="content">
      <Row class="headContent">
        <Col span="3" class="imgbox"><img :src="headData.logoPath.indexOf('http') == -1? $configUrl.futureImgUrl + headData.logoPath:headData.logoPath" alt=""></Col>
        <!-- <Col span="3" class="imgbox"><img :src="$configUrl.lsPath + logo" alt=""></Col> -->
        <Col span="2">

        </Col>
        <Col span="16">
          <Row class="nav">
            <!-- <Col :span="navLength" class="pointer navtab">
              <router-link :to="{name:'index'}">首页</router-link>
            </Col> -->
            <!-- <Col :span="navLength" class="pointer navtab" v-for="(item,index) in headData.nav_list" :key="index">
                <a :href="item.urlPath" v-if="item.type == 1" target="_blank">{{item.name}}</a>
                <div v-else-if="item.type == 0" class="pointer navtab">
                    <a :href="zyzxUrl" v-if="item.linkId == 1">{{item.name}}</a>
                    <router-link v-else-if="item.urlPathInside.includes('?')" :to="{path:item.urlPathInside,query:{name:encodeURI(item.name)}}">{{item.name}}</router-link>
                    <router-link :to="{path:item.urlPathInside}" v-else >{{item.name}}</router-link>
                </div>
            </Col> -->
            <Tabs @on-click="clickTab" :value="routerName">
                <Tab-pane label="首页" :name="String(-1)"></Tab-pane>
                <Tab-pane :label="item.name" v-for="(item,index) in navlist" :key="index" :name="String(index)"></Tab-pane>
                <Tab-pane name="application" label="应用中心" v-if="websiteId ==='50'">应用中心</Tab-pane>
            </Tabs>
          </Row>
        </Col>

        <Col span="3">
          <div class="loginbtn pointer" v-if="!isLogin" @click="login">登录</div>
          <div class="userbox" v-else>
            <img class="userimg" :src="headImg" :onerror="errorImg01" alt="">
            <div class="setbox">
              <div class="setItem" v-if="userType == 'teacher'" @click="toMySpace('teacher')"><a href="javascript:;"><img src="/static/images/myspace.png" alt="">我的空间</a></div>
              <div class="setItem" v-if="userType != 'teacher'" @click="toMySpace('student')"><a href="javascript:;"><img src="/static/images/myspace.png" alt="">我的空间</a></div>
              <!-- <div class="setItem" v-if="isHaveUserId"><router-link :to="{name:'dataCenter'}"><img src="/static/images/databg.png" alt="">数据中心</router-link></div>
              <div class="setItem" v-if="adminType != 0 && userType== 'teacher'"><a :href="'http://'+siteUsermanageUrl" target="_blank"><img src="/static/images/manager.png" alt="">管理中心</a></div>
              <div class="setItem"><a :href="'http://'+usercenterUrl+'/user/updateUserInfo'" target="_blank"><img src="/static/images/person.png" alt="">基本资料</a></div>
              <div class="setItem"><a :href="'http://'+usercenterUrl+'/user/userSecurity'" target="_blank"><img src="/static/images/accounts.png" alt="">账号安全</a></div> -->
              <div class="setItem" @click="loginOut"><a href="javascript:;"><img src="/static/images/exit.png" alt="">退出</a></div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  </div>

</template>
<script>
import api from '../../utils/api.js'
import cookie from '../../assets/getCookie.js'
export default {
  name: 'headTop',
  props: {
    logo: {
      type: String,
      default: ''
    },
    usercenterUrl: {
      type: String,
      default: ''
    },
    userName: {
      type: String,
      default: '登录'
    },
    siteResUrl: {
      type: String,
      default: ''
    },
    siteAppUrl: {
      type: String,
      default: ''
    },
    siteUrl: {
      type: String,
      default: ''
    },
    userImg: {
      type: String,
      default: null
    },
    hdbg: {
      type: String,
      default: null
    },
    headData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      urlPath: null, // 导航外部链接
      urlPathInside: null, // 导航内部链接
      zyzxUrl: null, // 资源中心url
      logoPath: null,
      adminType: 0,
      websiteId: null,
      siteUsermanageUrl: null,
      userId: null,
      isHaveUserId: false, // 是否有数据中心
      datacenter: '', // 获取回来的数据信息
      navname: 'index', // 路由跳转时样式的改动
      currentUrl: null,
      teacherName: '登录',
      siteUrlHead: null, // 首页
      siteAppUrlHead: null, // 应用市场
      siteResUrlHead: null, // 教学资源
      siteDomain: null,
      headImg: '/static/images/userImg.png',
      errorImg01: 'this.src="' + require('../../../static/images/userImg.png') + '"',
      tabName: null,
      isLogin: false,
      scroll: null,
      userType: '',
      iconPath: null,
      title: null,
      routerName: '',
      headactive:2,
    }
  },
  computed: {
    navLength () {
      const num = 24 / (this.headData.nav_list.length + 1)
      return parseInt(num)
    },
    navlist(){
      const arr = this.headData.nav_list
      let newarr = []
      // if(location.host === 'www.aixueyun.cn'){
      //   newarr = arr.filter(item=> item.name !=='资源中心') || []
      // }else{
      //   newarr = arr
      // }
      newarr = arr
      return newarr
    }
  },
  created () {
    // console.log('顶部信息',this.headData)
   
    if(localStorage.getItem('siteUsermanageUrl')){
      this.siteUsermanageUrl = localStorage.getItem('siteUsermanageUrl').replace('managecenter', 'manage')
    }
    this.userType = localStorage.getItem('userType')
    this.zyzxUrl = 'http://' + localStorage.getItem('siteResUrl')
    this.websiteId = localStorage.getItem('websiteId')
    this.adminType = cookie.getCookie('AXY_' + this.websiteId + '_adminType')
    this.userId = cookie.getCookie('AXY_' + this.websiteId + '_user_id')
    if (localStorage.getItem('userImg')) {
      let img = localStorage.getItem('userImg')
      img = img.replace(/"/g, '')
      this.headImg = 'http://account.aixueyun.cn/pic' + img
    }
    if (window.sessionStorage.getItem('routerIndex')) {
      this.routerName = window.sessionStorage.getItem('routerIndex')
    }
    console.log('jjj', this.$route.query.id)
    if (this.$route.query.id) {
      this.headData.nav_list.forEach((v, i) => {
        if (this.$route.query.id == v.id) this.routerName = String(i)
      })
    } else {
      this.routerName = ''
    }
  },
  watch: {
    userName: function (newVal) {
      this.teacherName = decodeURI(newVal)
    },
    siteUrl: function (newVal) {
      this.siteUrlHead = newVal
    },
    siteAppUrl: function (newVal) {
      this.siteAppUrlHead = newVal
    },
    siteResUrl: function (newVal) {
      this.siteResUrlHead = newVal
    },
    usercenterUrl: function (newVal) {
      this.usercenterUrl = newVal
    },
    '$route': {
      handler (to, from) {
        console.log('luyou', to)
        if (to.name === 'newsDetail') {
          this.routerName = '000'
        }
        if (to.name === 'application') {
          this.routerName = 'application'
        }
      }
    }
  },
  mounted () {
    // window.addEventListener('scroll', this.handleScroll)
    
    let that = this
    window.addEventListener('scroll', function () {
      let top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset// 要做兼容 在模拟器能正常获取scrolltop在微信h5页面和手机的浏览器页面一直为0
      if (top == 0 || top < 0) {
        that.headactive = 0
      } else {
        that.headactive = 1
      }
    })
    this.navname = sessionStorage.getItem('navname')
    this.siteDomain = localStorage.getItem('siteDomain')
    this.currentUrl = window.location.href
    let token = cookie.getCookie('AXY_' + localStorage.getItem('websiteId') + '_access_token')
    if (token == 'null' || token == null) {
      this.isLogin = false
    } else {
      this.getDataAnalysisAuthByUser()
      this.isLogin = true
    }
    if(this.$route.path==='/application'){
      this.routerName = 'application'
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollHandle)
  },
  methods: {
    clickTab (name) {
      if(name === 'application'){
        this.$router.push('/application')
        return
      }
      window.sessionStorage.setItem('routerIndex', name)
      if (name === '-1') {
        this.$router.push({name: 'Index'})
        return
      }
      const data = this.navlist[name]
      if (data.type === 1) {
        window.open(data.urlPath)
      } else {
        if (data.linkId === 1) {
          window.location.href = this.zyzxUrl
        } else if (data.urlPathInside.includes('?')) {
          this.$router.push({path: data.urlPathInside, query: {name: encodeURI(data.name), id: data.id}})
        } else {
          this.$router.push({path: data.urlPathInside, query: {id: data.id}})
        }
      }
    },
    // handleScroll() {
    //   this.scroll = document.documentElement.scrollTop||document.body.scrollTop;
    // },
    login () {
		this.$router.push({path: '/login'})
      // window.location.href = 'http://' + this.usercenterUrl + '/tologin?gotoUrl=' + this.currentUrl
    },
    removeLocalStorage () {
      localStorage.removeItem('userName')
      localStorage.removeItem('schoolId')
      localStorage.removeItem('userId')
      localStorage.removeItem('userType')
      localStorage.removeItem('userImg')
      localStorage.removeItem('accessToken')
      localStorage.removeItem('thirdToken')
      localStorage.removeItem('datacenter')
      localStorage.removeItem('adminType')
      localStorage.removeItem('iconPath')
    },
    loginOut () {
      // $.removeCookie("name",{ path: '/'});
      // $.cookie('name','123',{ path: '/'});
      // console.log('delCookie')
      var keys = document.cookie.match(/[^ =;]+(?==)/g)
      this.removeLocalStorage()
      // console.log(keys)
      if (keys) {
        for (var i = keys.length; i--;) {
          $.cookie(keys[i], null, {domain: this.siteDomain})
        }
      }
      if (this.$route.path == '/dataCenter') {
        this.$router.push({name: 'index'})
        this.isLogin = false
      } else {
        window.location.reload()
      }
    },
    getDataAnalysisAuthByUser () {
      const url = '/axt-usercenter/auth/getDataAnalysisAuthByUser'
      const that = this
      const params = {
        websiteId: this.websiteId,
        userId: this.userId
      }
      // console.log(params, "params")
      api.postFormAPI(url, params).then(res => {
        if (res.data.message === 'success') {
          if (res.data.data !== '' && res.data.data != null) {
            this.isHaveUserId = true
          } else {
            this.isHaveUserId = false
          }
          this.datacenter = res.data.data

          localStorage.setItem('datacenter', res.data.data)
        }
      })
    },
    toMySpace (name) {
      let third_token = localStorage.getItem('thirdToken').replace(/"/g, '')
      let adminType = localStorage.getItem('adminType')
      var accessToken = localStorage.getItem('accessToken')
      var backUrl = window.location.host
      if (name == 'teacher') {
        if (adminType != '0') {
          window.open('http://' + this.siteUsermanageUrl)
        } else {
          window.open(this.$configUrl.teacherPath + '/loading.html?token='+accessToken+'&backurl=' + backUrl)
        }
      } else {
        window.open(this.$configUrl.stuPath + '/thirdDocking/tokenlogin?token=' + third_token)
      }
    }
  }
}
</script>
<style lang="">
  #headtop .ivu-tabs-content{
    display: none;
  }
  /* headTop css */
  #headtop .ivu-tabs{
    height: 100%;
  }
  #headtop .ivu-row{
    height: 100%;
  }
  #headtop .ivu-tabs-bar{
    border-bottom: none;
    margin-bottom: 0;
    height: 100%;
  }
  #headtop .ivu-tabs-nav-container{
    color: #444444;
    font-size: 20px;
    height: 80px;
    line-height: 64px;
    transition: all .5s;
  }
  #headtop.active .ivu-tabs-nav-container{
    height: 60px;
    line-height: 48px;
  }
  #headtop .ivu-tabs-nav-wrap{
    height: 100%;
  }
  #headtop .ivu-tabs-nav-next,#headtop .ivu-tabs-nav-prev{
    transition: all .5s;
    line-height: 80px;
  }
  #headtop.active .ivu-tabs-nav-next,#headtop.active .ivu-tabs-nav-prev{
    line-height: 60px;
  }
</style>
<style scoped>
  #headtop {
    position: fixed;
    width: 100%;
    height: 80px;
    line-height: 80px;
    background: rgba(255, 255, 255, 0.9);
    left: 0;
    top: 0;
    z-index: 999;
    min-width: 1200px;
    transition: all .5s;
    box-shadow: 0px 3px 15px -4px rgba(0, 0, 0, 0.07);
  }
  #headtop.active {
    height: 60px;
    line-height: 60px;

  }
  .headContent .imgbox {
    text-align: left;
  }
  .headContent .imgbox img {
    height: 48px;
    vertical-align: middle;
    transition: all .5s;
  }
  #headtop.active .headContent .imgbox img {
    height: 40px;
  }
  .nav {
    justify-content:flex-end;
  }
  .nav .navtab > a{
    color: #444444;
    font-size: 20px;
    padding-bottom: 10px;
  }
  #headtop.active .nav .navtab > a {
    padding-bottom:5px;
  }
  .nav .navtab > a.router-link-exact-active, .nav .navtab > a:hover {
    color: #3583FF;
    border-bottom: 2px solid #3583FF;
  }
  .navtab {
    position: relative;
    height: 80px;
  }
  .navtab .navitembox {
    position: absolute;
    left: 0;
    top: 80px;
    line-height: 1;
    background-color: #fff;
    width: 100%;
    padding: 15px 10px;
  }
  .navtab .navitembox a {
    display: block;
    height: 30px;
    line-height: 30px;

  }
  .loginbtn {
    float: right;
    padding: 0 10px;
    height: 30px;
    line-height: 30px;
    color: #444444;
    border: 1px solid #444444;
    margin-top: 25px;
    border-radius: 4px;
    transition: all .5s;
  }
  #headtop.active .loginbtn {
    margin-top: 15px;
  }
  .loginbtn:hover {
    color: #3583FF;
    border-color: #3583FF;
  }
  .userbox {
    width: 148px;
    height: 50px;
    margin-top: 12px;
    position: relative;
    cursor: pointer;
    transition: all .5s;
  }
  #headtop.active .userbox{
    margin-top: 2px;
  }
  .userimg {
    display: block;
    margin: 0 auto;
    width: 36px;
    position: relative;
    top: 7px;
    height: 36px;
    border-radius: 50%;
  }
  .setbox {
    width: 148px;
    padding: 15px 0;
    background: #FFFFFF;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.14);
    border-radius: 6px;
    position: absolute;
    right: 0;
    z-index: 999;
    top: 48px;
    display: none;
  }
  .userbox:hover .setbox {
    display: block;
  }
   .setbox .setItem {
      height: 38px;
      line-height: 38px;
      font-size: 14px;
      color: #1A1A1A;
      text-align: left;
      cursor: pointer;
   }
   .setbox .setItem a {
     padding-left: 20px;
     display: block;
     color: #1A1A1A;
   }
   .setbox .setItem img {
     height: 14px;
     margin-right: 5px;
     position: relative;
     top: 2px;
   }
   .setbox .setItem:hover {
     background-color: #F4F4F4;
   }

   @media screen and (min-width: 1920px) {
     #headtop {
       height: 100px;
       line-height: 100px;
     }
     #headtop.active {
       height: 80px;
       line-height: 80px;
     }
     .headContent .imgbox img {
       height: 53px;
     }
     #headtop.active .headContent .imgbox img {
       height: 45px;
     }
     .loginbtn {
       margin-top: 35px;
     }
     #headtop.active .loginbtn {
       margin-top: 25px;
     }
     .nav a{
       padding-bottom: 10px;
     }
     #headtop.active .nav a {
       padding-bottom:10px;
     }
     .userbox {
       margin-top: 22px;
     }
     #headtop.active .userbox {
       margin-top: 12px;
     }
   }
</style>



// WEBPACK FOOTER //
// src/components/headtop/headTop.vue